export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'c1',
    name: '人善交理念',
    slug: 'ren-shan-jiao-li-nian',
    description: '深入理解"人善交"的核心理念与哲学基础，掌握善意社交的底层逻辑',
    icon: 'ri-lightbulb-line',
    articleCount: 2
  },
  {
    id: 'c2',
    name: '交友技巧',
    slug: 'jiao-you-ji-qiao',
    description: '实用的交友方法和策略，帮助你更有效地建立和维护高质量人际关系',
    icon: 'ri-hand-heart-line',
    articleCount: 3
  },
  {
    id: 'c3',
    name: '人际关系',
    slug: 'ren-ji-guan-xi',
    description: '探讨各种人际关系场景中的相处之道，包括职场、家庭、社交等',
    icon: 'ri-team-line',
    articleCount: 3
  },
  {
    id: 'c4',
    name: '良师益友',
    slug: 'liang-shi-yi-you',
    description: '发现人生中的引路人，学习如何与良师益友建立深厚的连接',
    icon: 'ri-star-line',
    articleCount: 1
  },
  {
    id: 'c5',
    name: '善意社交',
    slug: 'shan-yi-she-jiao',
    description: '以善意为核心的社交法则，让每一次交往都成为双向滋养',
    icon: 'ri-heart-line',
    articleCount: 2
  },
  {
    id: 'c6',
    name: '情感成长',
    slug: 'qing-gan-cheng-zhang',
    description: '在人际关系中获得情感成长，学会感恩、包容与自我提升',
    icon: 'ri-seedling-line',
    articleCount: 1
  }
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find(c => c.slug === slug);
};